﻿import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import {FormattedMessage, IntlShape, useIntl} from "react-intl";


interface NavSearchProps {
    IsActive: boolean;
    locale: string;
}

interface SearchHintModel {
    LinkText:string,
    LinkUrl:string,
    MatchPercentage:number,
    AffiliatedProduct:string,
    AffiliatedProductLocalised:string,
    AffiliatedProductType:string,
    IsArchivedAffilationProduct:boolean,
    IsConverge:boolean,
    ResultType:number,
    IsEol:boolean,
    ProductHero:string
}

const NavSearch = (props:NavSearchProps) => {
    
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState<SearchHintModel[]>([]);
    const searchRef = useRef(null);
    const resultSize = 10;

    const intl = useIntl();

    useEffect(() => {
        searchRef.current.focus();
    }, [props.IsActive]);
    
    const onSearchTextChangeHandler = (e:React.ChangeEvent<HTMLInputElement>) => {
        let cleanSearchText = e.target.value.replace(/<\/?[^>]+(>|$)/g, "");
        
        setSearchText(cleanSearchText);
        
        performSearch(cleanSearchText);
    }
    
    const performSearch = (searchText:string) => {
        //todo: this needs passing in as a prop
        let url = "/Products/Search/GetSearchHints"
        
        if(searchText == "" || searchText.length < 2) {
            setSearchResults([]);
            return;
        }
        
        let data = {
            "language":props.locale,
            "query":searchText
        }
        
        axios.post(url, data).then((res) => {
            setSearchResults(res.data)
        });
    }
    
    const buildSearchResult = (result:SearchHintModel):JSX.Element => {
        const boldString = result.LinkText.replace(RegExp(searchText, 'gi'), `<b>${searchText}</b>`);
        
        return (
            <span>
                <a href={result.LinkUrl} dangerouslySetInnerHTML={ { __html: boldString}}></a> 
                {/*todo: design and then show the product hero alongside the search result*/}
                {/*{result.ProductHero && result.ProductHero.length > 0 && <span className={"search_result_hero"}> - {result.ProductHero}</span>}*/}
            </span>
        )
    }
    
    return (
        <div className={`search ${props.IsActive ? "active" : null}`}>
            <div className={"submenu_content"}>
                <div className={"submenu_group"}>
                    <div className="search_container">
                        <input 
                            type={"text"} 
                            placeholder={intl.formatMessage({id: "Search.searchOptoma", defaultMessage: "Search Optoma"})}
                            ref={searchRef}
                            onChange={(e) => onSearchTextChangeHandler(e)}
                            value={searchText}
                        />
                    </div>

                    <div className={"search_results"}>
                        {searchResults.length == 0 &&
                        <div>
                            {/*<h4>Quick links</h4>*/}
                            {/*<ul>*/}
                            {/*    <li><a href="#">Optoma Projectors</a></li>*/}
                            {/*    <li><a href="#">Optoma Projector Lamps</a></li>*/}
                            {/*    <li><a href="#">Optoma Projector Screens</a></li>*/}
                            {/*    <li><a href="#">Optoma Projector Accessories</a></li>*/}
                            {/*</ul>*/}
                        </div>}

                        {searchResults.length > 0 &&
                            <div>
                                {/*<h4>Search results</h4>*/}
                                <h4><FormattedMessage id="Search.searchResults" defaultMessage="Search results" /></h4>
                                <ul>
                                    {searchResults.slice(0, resultSize).map((result) => {
                                        return (
                                            <li key={result.LinkUrl}>
                                                {buildSearchResult(result)}
                                            </li>
                                        )
                                    })}
                                </ul>

                                {searchResults.length > resultSize &&
                                    <div className={"search_more"}>
                                        <a href={`/search?query=${searchText}`}>
                                            <FormattedMessage id="Search.seeMoreResults" defaultMessage="See more results" />
                                            {/*See another {searchResults.length - resultSize} results*/}
                                        </a>
                                    </div>
                                }
                            </div>}
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default NavSearch